import { GraphQLClient } from "graphql-request";
import { useAtomValue } from "jotai";
import { useState } from "react";

import { authStorageAtom } from "../atoms";

const endpoint = process.env["NX_APP_API_DOMAIN"];
// console.log("NX_APP_API_DOMAIN", endpoint);
// const endpoint = "https://intra-api.mediacross.it";
// console.log("process.env.NX_APP_API_DOMAIN :>> ", process.env);

export function useGraphQLClient() {
  const [client] = useState(new GraphQLClient(`${endpoint}/graphql`));
  const authStorage = useAtomValue(authStorageAtom);

  const { token } = authStorage;

  // console.log("token", token);

  if (token) {
    const AUTH_TOKEN = `Bearer ${token}`;
    client.setHeaders({
      authorization: AUTH_TOKEN
    });
  } else {
    client.setHeaders({});
  }

  return { client, token };
}
